var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"producta"}},[_c('div',{staticClass:"top_tit"},[_c('span',{staticClass:"span1"},[_vm._v("产品介绍"+_vm._s(_vm.id))])]),_vm._v(" "),_c('div',{staticClass:"my_content",attrs:{"id":"my_content"},domProps:{"innerHTML":_vm._s(_vm.shuju)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4984c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/children/productb.vue
// module id = null
// module chunks = 